import { RandomJoke, SearchJoke } from '@jokerdad/components'
import { MainProvider, SWRProvider } from '@jokerdad/providers'
import { BrowserRouter as Router } from 'react-router-dom'

function App() {
  return (
    <MainProvider>
      <SWRProvider>
        <Router>
          <RandomJoke />
          <SearchJoke />
        </Router>
      </SWRProvider>
    </MainProvider>
  )
}

export default App
